import React, { useEffect, useState, lazy, Suspense } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { I18nProvider } from "./i18n";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { InstallProvider } from "./context/InstallContext";
import { Toaster } from "sonner";
import { api } from "./lib/api";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import Home from "./pages/Home";
const Menu = lazy(() => import("./pages/Menu"));
const Carta = lazy(() => import("./pages/Carta"));
const About = lazy(() => import("./pages/About"));
const Gallery = lazy(() => import("./pages/Gallery"));
const Events = lazy(() => import("./pages/Events"));
const Contact = lazy(() => import("./pages/Contact"));
const OrderConfirmation = lazy(() => import("./pages/OrderConfirmation"));
const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) { setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 250); return; }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function Shell() {
  const [settings, setSettings] = useState({ tax_percent: 15, whatsapp_number: "50582579338", currency: "C$" });
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");

  useEffect(() => { api.get("/settings").then((r) => setSettings(r.data)).catch(() => {}); }, []);

  useEffect(() => {
    const els = document.querySelectorAll(".reveal:not(.in), .fly-left:not(.in), .fly-right:not(.in)");
    if (!("IntersectionObserver" in window) || !els.length) {
      els.forEach((el) => el.classList.add("in"));
      return;
    }
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("in"); obs.unobserve(e.target); } });
    }, { threshold: 0.15 });
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, [loc.pathname]);

  return (
    <>
      <ScrollToTop />
      {!isAdmin && <Header />}
      <Suspense fallback={<div className="min-h-screen bg-[#0A192F]" />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/menu" element={<Menu settings={settings} />} />
        <Route path="/carta" element={<Carta />} />
        <Route path="/about" element={<About />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/events" element={<Events />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/order-confirmation" element={<OrderConfirmation settings={settings} />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
      </Routes>
      </Suspense>
      {!isAdmin && <Footer />}
      {!isAdmin && <CartDrawer settings={settings} />}
      <Toaster position="top-right" theme="dark" richColors closeButton />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <InstallProvider>
            <CartProvider>
              <BrowserRouter>
                <Shell />
              </BrowserRouter>
            </CartProvider>
          </InstallProvider>
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}
